import React from 'react';

const PortfolioFooter = () => {
  return (
    <footer className="portfolio-footer">
      <span>© 2026 Bill Bolte</span>
      <span>Built with care.</span>
    </footer>
  );
};

export default PortfolioFooter;

